export const GRADIENT_CLASSES = [
    "from-sky-400 to-blue-500",
    "from-yellow-400 to-orange-500",
    "from-pink-400 to-rose-500",
    "from-purple-400 to-indigo-500",
    "from-green-400 to-emerald-500",
    "from-cyan-400 to-teal-500",
    "from-amber-400 to-yellow-500",
    "from-violet-400 to-purple-500",
    "from-rose-400 to-pink-500",
    "from-emerald-400 to-green-500",
    "from-teal-400 to-cyan-500",
    "from-indigo-400 to-blue-500",
    "from-orange-400 to-red-500",
    "from-lime-400 to-green-500",
];

export function getGradientClass(index) {
    return GRADIENT_CLASSES[index % GRADIENT_CLASSES.length];
}

export const CARD_BORDER_GRADIENT = "linear-gradient(90deg, #38bdf8 0%, #fde047 100%)";

export const PAGE_TITLE_CLASS =
    "text-4xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-yellow-400 to-sky-400 mb-4";

export const PAGE_TITLE_UNDERLINE_CLASS =
    "w-24 h-1 bg-gradient-to-r from-sky-400 via-yellow-400 to-sky-400 mx-auto rounded-full";
